export const FORM_NAME = 'AccountStatement'
export const TRANSLATION_FORM_NAME = 'frm_acc_statement'

export const gridIdentity = {
  formName: 'frm_acc_statement',
  objectName: 'dbgrd_entries',
}

export interface OrderDetailRouteParams {
  ID: number
  OID: number
  OperTypeID: number
  EntryID: number | string
  HashSum_EntryID_: string
  HashSum_OID_: string
}
